var messengerFull = "https://shopfront-cdn.tekoapis.com/static/3ad4c9a97ab98ff3.png";

export { messengerFull as default };
